import { ShieldCheck, CheckCircle, Award } from 'lucide-react';

export const Guarantee = () => {
  return (
    <section className="py-20 bg-brand-dark relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-brand-base border border-brand-border rounded-3xl p-8 md:p-12 relative overflow-hidden">
           {/* Gold/Accent Gradient Border Effect on Top */}
           <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-50" />
           
           <div className="flex flex-col md:flex-row gap-8 items-center">
             
             {/* Icon / Badge Side */}
             <div className="flex-shrink-0">
               <div className="w-24 h-24 md:w-32 md:h-32 bg-gradient-to-br from-yellow-500/20 to-yellow-600/20 rounded-full flex items-center justify-center border-2 border-yellow-500/30 shadow-[0_0_30px_rgba(234,179,8,0.2)]">
                  <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 text-yellow-500" />
               </div>
             </div>

             {/* Content Side */}
             <div className="text-center md:text-left">
               <div className="inline-flex items-center gap-2 mb-4">
                 <Award className="w-5 h-5 text-yellow-500" />
                 <span className="text-yellow-500 font-bold uppercase tracking-widest text-sm">The North Forge Promise</span>
               </div>
               
               <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-6 font-display">
                 We Pay You If It Doesn't Work.
               </h3>
               
               <p className="text-lg text-slate-300 mb-8 leading-relaxed">
                 If our AI doesn't capture at least <span className="text-white font-bold">3 opportunities</span> you would have missed in your first month, we'll refund 100% of your subscription <span className="text-white font-bold">AND pay you $500</span> for wasting your time.
               </p>
               
               <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start text-sm font-medium text-slate-400">
                  <span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> No Risk</span>
                  <span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> No Hassle</span>
                  <span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> Instant Refund</span>
               </div>
             </div>
           </div>
        </div>
      </div>
    </section>
  );
};
